import type { Project } from "../../types";

export type ProjectGeneralForm = {
  readonly title: string;
  readonly description: string;
};

/**
 * Only the fields that actually changed, trimmed the same way the server
 * does — an empty title is never emitted, since the server would reject it
 * and the caller is expected to disable "Guardar" first via
 * `isProjectGeneralFormValid`.
 */
export const buildProjectMetaUpdate = (project: Project, form: ProjectGeneralForm) => {
  const title = form.title.trim();
  const description = form.description.trim() || null;
  return {
    ...(title.length > 0 && title !== project.name ? { title } : {}),
    ...(description !== project.description ? { description } : {}),
  };
};

/** A blank title can never be saved: the server requires a non-empty one. */
export const isProjectGeneralFormValid = (form: ProjectGeneralForm): boolean =>
  form.title.trim().length > 0;
